import { InjectionToken } from '@angular/core';

export const SERVICE_URL = new InjectionToken<string>('Service URL endpoint');
export const SHOWCASE_URL = new InjectionToken<string>('Showcase URL endpoint');
export const REPORTING_PATH = new InjectionToken<string>('Pfad zu Reporting');
